export default {
  payWelfareText: '儲值福利',
  blackFridayDiscount: '黑五限時折扣',
  shareGift: '分享有禮',
  vipWeeklyWelfare: 'VIP每週優惠',
  exchangeCoupon: '兌換優惠券',
  firstPayOff: '首次購買最高享15%OFF',
  blackFridayEvent: '黑五活動',
  limitedTimeOff: '限時優惠10%OFF',
  claimCoupon: '立即領券',
  blackFridayTimedCoupon: '黑五限時折扣券',
  timeLeft: '活動剩餘：',
  claimTimeCoupon: '限時領取10%OFF優惠券',
  points: '剩餘積分：${point}',
  costPointTip: '消耗積分即可領取任意檔位的優惠券',
  maxPointTip: '每個帳號最多使用500積分',
  discountOff: '10%OFF',
  highestDiscount: '最高優惠 ${discount} ',
  needPoint: '需要積分 ${point}',
  changeCurrency: '更換幣種',
  claim: '領取',
  claimSucc: '領取成功',
  claimFail: '領取失敗',
  pointNotEnough: '積分不足',
  afterClaimPoint: '領取後剩餘積分：${point}',
  footTips1: '每筆訂單限使用一張優惠券',
  footTips2: '購買代金券時不支援使用該優惠券',
  footTips3: '活動最終解釋權歸遊戲營運團隊所有',
  ruleTitleText: '活動規則',
  ruleTime: '活動時間：2023-11-24 0:00 ～ 2023-11- 26 23:59 （UTC）',
  bfRuleText1:
    '1、活動期間，帳號首次登入官網儲值頁面獲得400積分，可用于兌換優惠券，最高可使用500積分；',
  bfRuleText2:
    '2、活動期間，使用黑五積分可以兌換任意額度的優惠券，優惠額度越高，需要的積分越多。兌換成功後會扣除對應的積分；',
  bfRuleText3: '3、每筆訂單限使用一張優惠券，代金券商品不支援使用黑五優惠券；',
  bfRuleText4: '4、黑五優惠券僅支持以下幣種：',
  ableCoinsType: 'USD,JPY,KRW,TWD,EUR,HKD,GBP,CAD,AUD,RUB,MYR,THB,PLN,IDR',
  bfRuleText5:
    '5、兌換成功後，不支持更換幣種，也不支持退還積分，請留意優惠額度和積分消耗；',
  bfRuleText6: '6、黑五優惠券有效期7天，請留意使用；',
  bfRuleText7: '7、活動最終解釋權歸遊戲營運團隊所有；',
  thanksTip: '感謝您的參與，更多支付活動請關注官方社群',
  exchangePoints: '兌換優惠券',
  exchangeCode: '輸入優惠碼',
  enterExchangeCode: '在這裡輸入優惠碼',
  exchangeText: '兌換',
  confirmGet: '確認領取',
  couponUsedWay:
    '優惠券僅支持在指定幣種的支付管道使用，請確認您希望使用的支付幣種',
  confirmText: '確認',
  exchangeSucc: '兌換成功',
  aboutCoins: '關於代金券',
  aboutCoinsText: '代金券可用於兌換本遊戲中除了代金券以外的所有禮包及增值服務',
  known: '我知道了',
  codeText: '兌換碼',
  codeInvalid: '兌換碼失效！',
  hasExchanged: '您已兌換，兌換碼只可以領取1次！',
  hideText: '收起',
  //黑五的报错码
  'bf-20001': '未登錄',
  'bf-20002': '參數錯誤，請嘗試重新進入活動',
  'bf-20003': '積分不足',
  'bf-20004': '領取失敗，請稍後再試或聯繫客服',
  'bf-20005': '已領取',
  'bf-20015': '活動未開啟，敬請期待',
  'bf-20016': '活動已結束',
  bfShareText: '限時領取10%OFF優惠券',
  rightsCenterBtn: '大會員中心',
  payBtn: '儲值',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: '購買失敗',
  productInterceptPopupTip: '抱歉該地區不支持購買該禮包<br>如有任何疑問可向客服進行諮詢',
  productInterceptPopupConfirm: '好的',
  vipHeadAwardText285 : '榮耀超凡（永久）',
  rightCenterNoticeTitle: '關於VIP積分機制升級為【權益中心】',
  rightCenterNoticeContent: '尊敬的指揮官：<br />感謝您一直以來的支持！為提供更優質的福利體驗，我們將於2025年7月16日對原有VIP積分機制進行全面改版升級，推出全新「大會員中心」系統。此次改版將整合原有VIP權益，並新增更多福利，具體調整如下：<br />一、改版內容說明<br />每週登入福利保留<br />2025年7月16日-7月29日期間，所有玩家登入【官網儲值頁】仍可領取「每週VIP優惠券」，可獲得優惠券數量與【VIP積分活動】一致。同時，所有玩家可以在【大會員中心】兌換新版優惠券，權限中心優惠券將會有最高抵扣金額限制，新優惠券規則及可獲取數量可參考頁面下方表格<br />請注意：自動發放優惠券功能需手動開啟，開啟路徑：權益中心首頁-查看會員權益-優惠券自動發放-點擊開啟-選擇需要自動兌換的優惠券-確認開啟<br />新增積分兌換福利<br />權益中心將開放「積分兌換」功能，玩家可透過參與登入遊戲、完成權益中心指定任務等方式獲取積分，兌換專屬優惠券、稀有道具等超值獎勵（具體可兌換數量詳見權益中心界面）。<br />VIP等級繼承保障<br />原VIP等級及累計積分將完整繼承至權益中心，並自動轉換為對應權益中心的等級身份，原有VIP特權將同步保留且優化升級。<br />二、改版後優勢<br />權益更透明：所有福利規則及兌換內容清晰展示，一鍵領取便捷無憂。<br />回饋更豐厚：新增積分兌換活動，高價值道具不定期更新。<br />抽獎福利：除了積分兌換以外，還會加入抽獎活動，可以獲取遊戲內道具獎勵。<br />三、注意事項<br />改版過渡期間（2025年7月16日-7月29日），原VIP積分入口將逐步關閉（但關閉前仍正常發放優惠券），請及時使用剩餘優惠券，【VIP積分活動】關閉後未使用的優惠券將失效。<br />權益中心上線後，您可透過【官方儲值中心】-【頭像】-進入【權益中心】',
  rightCenterNoticeTableTitle: '優惠券變動對比',
  rightCenterNoticeTableHeader1: '兌換門檻-大會員等級',
  rightCenterNoticeTableHeader2: '原VIP等級',
  rightCenterNoticeTableHeader3: '優惠券折扣',
  rightCenterNoticeTableHeader4: '獲取限制',
  rightCenterNoticeTableHeader5: '折抵上限',
  rightCenterNoticeTableLevel1: '青銅',
  rightCenterNoticeTableLevel2: '白銀', 
  rightCenterNoticeTableLevel3: '黃金',
  rightCenterNoticeTableLevel4: '白金',
  rightCenterNoticeTableLevel5: '鑽石',
  rightCenterNoticeTableCount1: '1次/日',
  rightCenterNoticeTableCount2: '15次/月',
  rightCenterNoticeTableCount3: '每月10次',
  rightCenterNoticeTableLimit: '15美元',
  rightCenterNoticeTableTip: '請注意：【權益中心】優惠券折抵上限以美元為基準，受匯率波動影響，以實際使用頁面顯示為準',
  '-': '-'
};
